import { StaffuseAuth } from "../../security/StaffuseAuth";

export const Secret = () => {
  const { logout } = StaffuseAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div>
      <h1>This is a Secret page</h1>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};
